<!-- <p>manage-visitor-pass-dialog works!</p> -->
<div
  [ngClass]="{
    'manage-visitor-pass-container': data.screen === 1 || data.screen === 2,
    'manage-visitor-pass-container-mobile': data.screen === 3
  }"
>
  <div class="mat-dialog-header">
    <h4 *ngIf="data.screen !== 3">Renew/Suspend Visitor</h4>
    <h6 *ngIf="data.screen === 3">Renew/Suspend Visitor</h6>
    <button mat-mini-fab mat-dialog-close cdkFocusInitial>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="mat-dialog-content">
    <div style="width: 100%">
      <div class="visitor-search-field">
        <mat-form-field
          hideRequiredMarker
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>Search Visitor</mat-label>
          <input
            matInput
            [formControl]="visitorFilter"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            (optionSelected)="visitorSelect($event)"
            #auto="matAutocomplete"
          >
            <mat-option
              *ngFor="let visitor of filteredVisitor"
              [value]="visitor.firstName + ' ' + visitor.lastName"
            >
              {{ visitor.firstName + " " + visitor.lastName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <mat-divider></mat-divider>
      <div class="selected-visitor-field">
        <mat-grid-list [cols]="data.screen === 3 ? 2 : 3" rowHeight="45px">
          <mat-grid-tile *ngFor="let visitor of filteredVisitor">
            <div class="grid-tile-content">
              <div class="role-checkbox">
                <mat-checkbox
                  (change)="onCheckboxChange($event, visitor)"
                  class="example-margin"
                  [checked]="isChecked(visitor)"
                  >{{
                    visitor.firstName + " " + visitor.lastName
                  }}</mat-checkbox
                >
              </div>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
      <mat-divider></mat-divider>
      <div
        *ngIf="visitorsManagePass.length > 0"
        [ngClass]="{
          'selected-visitor-details': data.screen === 1 || data.screen === 2,
          'selected-visitor-details-mobile': data.screen === 3
        }"
      >
        <div
          class="select-visitor-pass-detail"
          *ngFor="let pass of visitorsManagePass; let i = index"
        >
          <b
            >{{ i + 1 + "." }} &nbsp;
            {{ pass.visitor.firstName + " " + pass.visitor.lastName }} &nbsp; |
            &nbsp; {{ "E-Validty:" }} &nbsp;{{
              pass.visitor.ePassValidity | date : "MMM d, y, hh:mm a"
            }}</b
          >
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="mat-dialog-action">
      <button
        (click)="onReNewVisitor()"
        [disabled]="visitorsManagePass.length == 0"
        mat-raised-button
      >
        Re-New
      </button>
      <button
        (click)="onSuspendVisitor()"
        [disabled]="visitorsManagePass.length == 0"
        mat-raised-button
      >
        Suspend
      </button>
    </div>
  </div>
</div>
<!-- Re-New Dialog Content -- -->
<ng-template #ReNewDialog>
  <h2 style="text-align: center" matDialogTitle>Select Pass Validity!</h2>
  <mat-dialog-content [formGroup]="passValidityForm">
    <mat-radio-group
      aria-label="Select an option"
      formControlName="option"
      (change)="updateMaxLength($event.value)"
    >
      <mat-radio-button value="Days">Days</mat-radio-button>
      <mat-radio-button value="Weeks">Weeks</mat-radio-button>
      <mat-radio-button value="Months">Months</mat-radio-button>
      <mat-radio-button value="Years">Years</mat-radio-button>
    </mat-radio-group>

    <mat-divider></mat-divider>
    <div
      class="option-field-wrapper"
      *ngIf="passValidityForm.get('option').value"
    >
      <mat-form-field [hintLabel]="errorMessage" appearance="outline">
        <mat-label>Enter {{ selectedOption }}</mat-label>
        <input
          matInput
          #input
          formControlName="value"
          (keypress)="inputValidator($event)"
        />
        <!-- <mat-hint align="end"
          >{{ input.value.length }}/{{ maxLength }}</mat-hint
        > -->
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      [disabled]="passValidityForm.invalid"
      (click)="onSubmit()"
      mat-raised-button
    >
      Save
    </button>
  </mat-dialog-actions>
</ng-template>
<ng-template #SaveDialog>
  <h2 matDialogTitle>Please wait!</h2>
  <mat-dialog-content>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
